module.exports = __webpack_public_path__ + "img/aracataca.7943d848.jpg";